import { Product, Rates } from 'pleinchamp-api-client';
import { OpUnitType } from 'dayjs';

export interface Filter {
  i18nKey: string;
  count: number;
  dateUnit: OpUnitType;
  stepUnit: OpUnitType;
}

export interface CattleProductType {
  cattleTypeId: number;
  products: Product[];
  rates: Rates;
}

export enum StocksHomeTabs {
  Crops = 'grandes-cultures',
  Cattle = 'betail-vif',
  Pork = 'porc',
  CattleFood = 'aliments-du-betail',
  Energies = 'intrants',
}

export enum StockSource {
  Agritel = 'Agritel',
  FMBV = 'FMBV',
  FinanceAgri = 'FinanceAgri',
}

export enum StockDetailsPath {
  Crops = 'grandes-cultures',
  Cattle = 'betail-vif',
  Pork = 'porc',
  CattleFood = 'aliments-du-betail',
  Energies = 'intrants',
  TermMarkets = 'marches-a-terme',
}
